import * as React from "react";
import { Upload } from "@grandvisionhq/api-client";
import { useApiConfig, uninitState, statusSuccess, loadingState, successState, failedState } from "@grandvisionhq/state";
const UploadContext = React.createContext({});
const useUpload = () => React.useContext(UploadContext);
const UploadProvider = ({
  scopes,
  shouldFetchConfigs = true,
  timeout = 2e4,
  children
}) => {
  const timersRef = React.useRef({});
  const mountRef = React.useRef(true);
  const { apiUrl } = useApiConfig();
  const [state, dispatch] = React.useReducer(
    (s, action) => {
      if (action.name === "error") {
        return { ...s, error: action.value };
      }
      return { ...s, configs: { ...s.configs, [action.name]: action.value } };
    },
    {
      scopes,
      error: null,
      configs: scopes.reduce((m, scope) => ({ ...m, [scope]: uninitState() }), {})
    }
  );
  function setError(error) {
    dispatch({ name: "error", value: error });
  }
  function updateConfig(scope, result) {
    if (!mountRef.current) {
      return;
    }
    dispatch({ name: scope, value: result });
  }
  React.useEffect(() => {
    if (!shouldFetchConfigs) {
      return;
    }
    mountRef.current = true;
    const abortController = new AbortController();
    const signal = abortController.signal;
    for (const scope of scopes) {
      const scopeState = state[scope];
      if (scopeState && statusSuccess(scopeState)) {
        continue;
      }
      updateConfig(scope, loadingState());
      timersRef.current[scope] = window.setTimeout(() => {
        abortController.abort();
      }, timeout);
      Upload.getConfig(apiUrl, { scope }, { signal }).then((response) => {
        clearTimeout(timersRef.current[scope]);
        updateConfig(scope, successState(response));
      }).catch((error) => {
        clearTimeout(timersRef.current[scope]);
        updateConfig(scope, failedState(error));
      });
    }
    return () => {
      abortController.abort();
      mountRef.current = false;
    };
  }, [scopes, shouldFetchConfigs]);
  return /* @__PURE__ */ React.createElement(UploadContext.Provider, { value: { ...state, setError } }, children);
};
export {
  UploadContext,
  UploadProvider,
  useUpload
};
//# sourceMappingURL=UploadProvider.js.map
